import React from "react";
import {BaseComponent} from "@renta-apps/athenaeum-react-common";
import {getLabelColSpan, ITotalsLayout, PageTotalValues, renderTotalsValueCells} from "../TotalsTable/TotalsLayout";
import Localizer from "../../../../localization/Localizer";

import styles from "../TotalsTable/TotalsTable.module.scss";

interface IPageTotalsProps {
    layout: ITotalsLayout;
}

interface IPageTotalsState {
    totals: PageTotalValues | null;
}

/**
 * "Total (this page)" row of the Daily hours totals table.
 * The values are pushed in by the owner through {@link setTotalsAsync}, so updating them re-renders only this row and never the grid itself.
 */
export default class PageTotals extends BaseComponent<IPageTotalsProps, IPageTotalsState> {

    state: IPageTotalsState = {
        totals: null,
    };

    public async setTotalsAsync(totals: PageTotalValues | null): Promise<void> {
        await this.setState({totals});
    }

    public render(): React.ReactNode {
        const totals: PageTotalValues | null = this.state.totals;

        if (totals == null) {
            return null;
        }

        const layout: ITotalsLayout = this.props.layout;

        return (
            <tr id="workDayPageTotals" className={styles.pageTotalsRow}>

                <td id="workDayPageTotalsLabel"
                    className={styles.label}
                    colSpan={getLabelColSpan(layout)}
                >
                    {Localizer.workDayPanelPageTotal}
                </td>

                {renderTotalsValueCells(layout, totals, "workDayPageTotal_", styles.value)}

            </tr>
        );
    }
}
